import React from 'react';
import { Close, Search } from 'grommet-icons';
import { Box, Button, TextInput } from 'grommet';
import {BorderType} from "grommet/utils";

type SearchInputProps = {
  onBlur?: () => void;
  onChange: (event: any) => void;
  clearSearchBarCallBack?: () => void;
  boxRef?: React.MutableRefObject<HTMLInputElement>;
  hint: string;
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  button?: boolean;
  border?: BorderType;
  height?: string;
  width?: string;
};

const SearchInput = ({
  boxRef,
  hint,
  onChange,
  clearSearchBarCallBack,
  onBlur,
  setValue,
  value,
  button = true,
  border,
  height,
  width
}: SearchInputProps): JSX.Element => {
  const style: any = {};

  if (height) {
    style.maxHeight = height;
  } else {
    style.minHeight = '3rem';
  }

  if (width) {
    style.maxWidth = width;
  }

  return (
    <Box
      background={'#fff'}
      border={border ?? { color: '#282828', size: 'small', style: 'solid' }}
      style={style}
      direction='row'
      align='center'
      ref={boxRef}
    >
      <TextInput
        data-cy='input-searchbar'
        dropTarget={boxRef ? boxRef.current : undefined}
        plain
        focusIndicator={false}
        placeholder={hint}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />
      {button && <Button
        hoverIndicator='none'
        icon={
          value ? (
            <Close
              color='#282828'
              size='20px'
              style={{ verticalAlign: 'middle' }}
            />
          ) : (
            <Search
              color='#282828'
              size='20px'
              style={{ verticalAlign: 'middle', cursor: 'default' }}
            />
          )
        }
        onClick={() => {
          setValue(value ? '' : value);
          if (clearSearchBarCallBack) {
            clearSearchBarCallBack();
          }
        }}
      />}
    </Box>
  );
};

export default SearchInput;
